<div class="pointsContainer">
  <div class="pointPart pointPartText tableWrapper">
    <div class="tableHeader">
      <h1>{{ 'List' | translate }}</h1>
      <div class="headerBtns">
        <!-- Search by Project ID -->
        <div class="add-sample-form">
          <input matInput placeholder="" [(ngModel)]="searchValue" />
          <button class="addButton" (click)="onSearch()">
            {{ 'Search Project ID' | translate }}
          </button>
        </div>

        <!-- Date Range Filter -->
        <div class="date-range-form">
          <!-- From Date -->
          <input matInput [matDatepicker]="pickerFrom" placeholder="{{ 'From Date' | translate }}" [(ngModel)]="startDate" (focus)="pickerFrom.open()" (click)="pickerFrom.open()" readonly />
          <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>

          <!-- To Date -->
          <input matInput [matDatepicker]="pickerTo" placeholder="{{ 'To Date' | translate }}" [(ngModel)]="endDate" (focus)="pickerTo.open()" (click)="pickerTo.open()" readonly />
          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>

          <button class="addButton" (click)="applyDateRange()">
            {{ 'Filter' | translate }}
          </button>
          <button class="addButton" (click)="clearDateRange()">
            {{ 'Clear' | translate }}
          </button>
        </div>
      </div>
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 userTable" matSort *ngIf="this.totalOrders">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{ 'Project ID' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'Project Name' | translate }}</th>
        <td mat-cell *matCellDef="let element" class="clicked" (click)="navigateToVendor(element.id)">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="orders">
        <th mat-header-cell *matHeaderCellDef>{{ 'Number of Orders' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.orders }}</td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>{{ 'Total Revenue' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.orders == 0"> 0 </span>
          <span *ngIf="element.orders != 0">{{ element.total }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="creationDate">
        <th mat-header-cell *matHeaderCellDef>{{ 'Registration Date' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.creationDate }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons aria-label="Select page of periodic data"></mat-paginator>
  </div>
</div>
